import React from 'react';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { ICONS_PATH } from '~/src/constants';

import * as ST from './styled';

export interface IButtonProps {
    btnTextDesktop?: string,
    btnTextMobile?: string,
    iconNameDesktop?: string,
    iconNameMobile?: string,
    isDisabled?: boolean,
    onButtonClick?: (() => void) | null,
}

export const ButtonElement = ({
    btnTextDesktop = 'Добавить',
    btnTextMobile = '',
    iconNameDesktop,
    iconNameMobile,
    isDisabled,
    onButtonClick,
} : IButtonProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    if (!onButtonClick) {
        return <></>;
    }

    return (
        <ST.Button
            size={btnSizes.MIDDLE}
            type={btnTypes.SECONDARY}
            text={isMobile ? btnTextMobile : btnTextDesktop}
            iconsSprite={ICONS_PATH}
            symbolId={isMobile ? iconNameMobile : iconNameDesktop}
            onClick={onButtonClick}
            disabled={isDisabled}
        />
    );
};
